// The tenant feature `cms` (#160 AF20), as the portal learns it.
//
// The flag is server truth: with it off, every cms root answers
// FEATURE_DISABLED. The portal has no flag query of its own, so it learns
// the answer from the first cms call it makes — the shell's probe for an
// editor (MainLayout → probeCmsFeature), the site menu, or the Website tool
// itself — and hides the Website tool once it knows the feature is off.
// Unknown counts as on: the entry is a first-frame hint like every rail hint,
// and the tool says so in place if the server refuses.
import { reactive } from 'vue'
import type { Client } from '@urql/vue'
import { CmsFeatureProbeDocument } from './cmsFeature.operations'
import { hasErrorCode } from 'src/modules/cms/cmsRender'

export const cmsFeature = reactive({
  /** The server answered FEATURE_DISABLED. */
  off: false,
  /** The shell's probe ran (once per session). */
  probed: false,
})

/** Records what a cms answer says about the flag. */
export function noteCmsAnswer(error: unknown): void {
  if (hasErrorCode(error, 'FEATURE_DISABLED')) cmsFeature.off = true
  else if (!error) cmsFeature.off = false
}

/** Asks once per session whether the cms answers (editors only). */
export async function probeCmsFeature(client: Client): Promise<void> {
  if (cmsFeature.probed) return
  cmsFeature.probed = true
  try {
    const r = await client.query(CmsFeatureProbeDocument, {}).toPromise()
    if (hasErrorCode(r.error, 'FEATURE_DISABLED')) cmsFeature.off = true
  } catch {
    // Unreachable is not "off": the tool will say what is wrong.
  }
}

/** Test seam. */
export function resetCmsFeature(): void {
  cmsFeature.off = false
  cmsFeature.probed = false
}
